import { render, staticRenderFns } from "./WPagination.vue?vue&type=template&id=ac56f5c0&"
import script from "./WPagination.vue?vue&type=script&lang=js&"
export * from "./WPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports